/**
 * Shared formatting helpers for currency and date display.
 *
 * Date formatters are time-zone aware:
 *   - Civil date strings (yyyy-MM-dd) — rendered as-is, never shifted.
 *   - Full timestamps (ISO with offset / Z) — converted to the company TZ
 *     read from the Vuex `company` module (fallback: Asia/Kolkata).
 */

import { currentTz } from "@/helpers/dateHelpers";
import {
  formatDateInTz,
  formatDateLongInTz,
  formatDateTimeInTz,
} from "@/helpers/dateHelpers.core.mjs";

/**
 * Format a number as Indian currency (e.g. 1,23,456.78)
 */
export function formatCurrency(val) {
  if (val === null || val === undefined || val === "") return "0.00";
  return Number(val).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatDate(dateStr, opts = {}) {
  return formatDateInTz(dateStr, currentTz(opts.tz));
}

export function formatDateLong(dateStr, opts = {}) {
  return formatDateLongInTz(dateStr, currentTz(opts.tz));
}

export function formatDateTime(dateStr, opts = {}) {
  return formatDateTimeInTz(dateStr, currentTz(opts.tz));
}

/**
 * Safely parse a JSON string, returning null on failure.
 */
export function safeParseJson(str) {
  if (!str) return null;
  try {
    return JSON.parse(str);
  } catch {
    return null;
  }
}

/**
 * Map audit action to Bootstrap badge class.
 */
export function auditActionBadgeClass(action) {
  if (action === "Create") return "badge bg-success-subtle text-success";
  if (action === "Update") return "badge bg-warning-subtle text-warning";
  if (action === "Delete") return "badge bg-danger-subtle text-danger";
  return "badge bg-secondary-subtle text-secondary";
}
